import { Node, Path } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import { hostsBlocks } from './insert';
import { countLayoutAncestors } from './wrap';

const types = serializer.types;
const layoutUtilities = serializer.utilities.node.layout;

// Whether a drop plan is allowed: never onto or into a dragged block, never columns into a layout,
// and always within the depth limit. A plan is { kind: 'move', parentPath, index, targetPath } or
// { kind: 'wrap', targetPath, direction: 'row' | 'column', side: 'start' | 'end' } (spec 3.9).

function isSourceOrInside(sourcePaths, path) {

  for (let index = 0; index < sourcePaths.length; index++) {
    if (Path.equals(sourcePaths[index], path) === true || Path.isAncestor(sourcePaths[index], path) === true) {
      return true;
    }
  }

  return false;

}

function containsColumns(node) {

  if (node.type === types.COLUMNS || node.type === types.COLUMN) {
    return true;
  }

  for (let index = 0; index < (node.children || []).length; index++) {
    if (containsColumns(node.children[index]) === true) {
      return true;
    }
  }

  return false;

}

// Layouts around a child of the block at parentPath.
function countAt(editor, parentPath) {

  if (parentPath.length === 0) {
    return 0;
  }

  let count = countLayoutAncestors(editor, parentPath);

  if (Node.get(editor, parentPath).type === types.LAYOUT) {
    count++;
  }

  return count;

}

function canPlace(editor, path, count) {

  const node = Node.get(editor, path);

  if (count > 0 && (hostsBlocks(editor, path) === false || containsColumns(node) === true)) {
    return false;
  }

  return layoutUtilities.canNest(count, node);

}

function canPlaceAll(editor, paths, count) {

  for (let index = 0; index < paths.length; index++) {
    if (canPlace(editor, paths[index], count) === false) {
      return false;
    }
  }

  return true;

}

export function canApplyDrop(editor, sourcePaths, plan) {

  if (sourcePaths.length === 0 || isSourceOrInside(sourcePaths, plan.targetPath) === true) {
    return false;
  }

  if (plan.kind === 'move') {
    return isSourceOrInside(sourcePaths, plan.parentPath) === false && canPlaceAll(editor, sourcePaths, countAt(editor, plan.parentPath));
  }

  const count = countAt(editor, Path.parent(plan.targetPath)) + 1;

  return canPlace(editor, plan.targetPath, count) === true && canPlaceAll(editor, sourcePaths, count) === true;

}
